module.exports = __webpack_public_path__ + "img/trail_of_burning_doom.35df459a.png";